import { createContext } from 'react';

import type { FrontpageResponseData } from '../types';

interface ViewContextType {
  data: FrontpageResponseData | null;
  setData(data: FrontpageResponseData | null): void;
}

export const ViewContext = createContext<ViewContextType>({
  data: null,
  setData: () => {}
});

export const ViewProvider = ViewContext.Provider;
